import * as React from 'react';
import { WhyNeedSdelkaLayout } from '../../../components/WhyNeedSdelka';
import { WHY_NEED_SDELKA_ITEMS } from './constants';
import { WhyNeedSdelkaItem } from '../../../components/WhyNeedSdelka/WhyNeedSdelkaItem';

export const WhyNeedSdelkaContainer: React.FC = () => {
  return (
    <WhyNeedSdelkaLayout>
      {WHY_NEED_SDELKA_ITEMS.map((item, index) => (
        <WhyNeedSdelkaItem key={item.title + index} {...item} />
      ))}
    </WhyNeedSdelkaLayout>
  );
};
